import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import UserBasicInfoContext from '../../../../components/Context/UserBasicInfoContext';
import init from '../../AccessControl/Check';


export default function ViewAccess() {
    const pageName = "Access View";
    const isAccess = init(pageName);


    const profile = useContext(UserBasicInfoContext);


    const navigate = useNavigate();
    const params = useParams();


    const [roleDetails, setRoleDetails] = useState("");

    useEffect(() => {
        if (params?.id === "" || isNaN(params?.id) === true) {
            return;
        }

        // Check
        const id = params?.id;
        PostLoginGetApi("manage/role/" + id, "", 3).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {


                    if (profile?.id > 0 && responseData.data.is_default === 0) {
                        if (responseData.data.created_by !== profile?.id) {
                            toast.error("You are not allowed to edit this role access.");
                            navigate("/dashboard/role");
                            return;
                        }
                    }


                    setRoleDetails(responseData.data);
                    return;
                }

                toast.error(responseData["messages"].toString() + "");
                navigate("/dashboard/role");
                return;
            }

            navigate("/dashboard/role");
            return;

        }).catch((error) => {
            console.log(error);
        });

    }, [navigate, params]);


    // Permission lists based on Role Id
    const [allPermissionsGroup, setAllPermissionsGroup] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [companyAccess, setCompanyAccess] = useState([]);

    useEffect(() => {
        if (isNaN(roleDetails.id) === true) {
            return;
        }

        PostLoginGetApi("permission/" + roleDetails.id + "/has-roles", "", 3).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setCompanyAccess(responseData.data[1]);

                    setPermissions(responseData.data[2]);
                    setAllPermissionsGroup(Object.keys(responseData.data[2]));
                    return;
                }
            }
        }).catch((error) => {
            console.log(error);
        });

    }, [roleDetails]);


    // Currently Owned Company
    const [ownedCompany, setOwnedCompany] = useState([]);
    useEffect(() => {
        PostLoginGetApi("company/lists/switch").then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setOwnedCompany(responseData.data);
                    return;
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    }, []);


    function checkCompanyAccess(company_id) {
        if (companyAccess.includes(company_id)) {
            return 1;
        }

        return 0;
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className='custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20'>

            <div className="custom-container w-full font-montserrat flex">

                <div className="custom-container-left float-left custom-scroll-auto w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                    <div className="text-justify rounded-[5px] py-3 pt-0">
                        <div className="w-1/2 float-left">
                            <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-4 mb-5">Here’s your Role Access at a glance</h6>
                        </div>


                        <div className="h-[68px] float-right text-right justify-end flex items-center">
                            <Link to={"/dashboard/role"} className="custom-btn text-center">Back to role list</Link>
                        </div>

                        {(roleDetails.is_default === 0) &&
                            <div className="h-[68px] float-right text-right justify-end flex items-center mr-4">
                                <Link to={"/dashboard/role/access-edit/" + roleDetails.id} className="py-[11.5px] px-[30px] text-white bg-primary rounded cursor-pointer hover:bg-brand-dark disabled:bg-gray-300">Edit</Link>
                            </div>
                        }
                    </div>


                    {(roleDetails.length === 0) ? "Loading..." :

                        <>
                            <table className="custom-details-table w-full mt-0 mb-2">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold text-base">Role Name</td>
                                        <td className="px-5 text-base">
                                            <p>{roleDetails.name}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold text-base">Code</td>
                                        <td className="px-5 text-base">
                                            <p>{roleDetails.code}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>


                            <table className="custom-details-table w-full mt-0 mb-2">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold text-base" colSpan={2}>Company Access</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div className='flow-root'>
                                {(ownedCompany?.length > 0) && ownedCompany.map((data, index) => (
                                    <span key={index} >
                                        {(checkCompanyAccess(data.id) === 1 || roleDetails.is_default === 1) &&
                                            <div className="w-[24%] float-left border border-gray-200 rounded-md px-2 py-3 m-1 hover:bg-gray-100">
                                                <span className='font-semibold'>{index + 1}.</span> {data.name}
                                            </div>
                                        }
                                    </span>
                                ))}
                            </div>


                            <table className="custom-details-table w-full mt-3 mb-2">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold text-base" colSpan={2}>Page Access / Control</td>
                                    </tr>

                                </tbody>
                            </table>


                            {(allPermissionsGroup?.length > 0) &&
                                allPermissionsGroup.map((data, index) => (
                                    <div key={index}>
                                        <li className='font-semibold ml-2'>{data}</li>

                                        <div className='flow-root w-full my-1'>
                                            {permissions[data.toString()].map((data2, index2) =>
                                                <div key={index2} className="w-[24%] m-2 cursor-pointer content-center float-left border border-gray-200 rounded-md px-4 py-3 hover:bg-gray-100">
                                                    {data2}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))
                            }
                        </>

                    }

                </div>


            </div>


        </div>
    )
}
